module.exports = __webpack_public_path__ + "img/com.aeg.myaeg.taste.b1eda4b0.webp";